/**
 * Reward API
 * Handles reward and redemption endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class RewardAPI extends BaseAPI {
    /**
     * Fetch user reward balances
     */
    fetchRewardBalances(walletAddress, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.get(`${this.env.API_URL}reward/sdk/balances?walletAddress=${walletAddress}`, {
                    "x-access-token": token,
                    Authorization: `Bearer ${token}`,
                    "x-public-key": this.env.ME_API_KEY,
                });
                return result.data || [];
            }
            catch (error) {
                console.error("Error fetching reward balances:", error);
                throw error;
            }
        });
    }
    /**
     * Fetch swap amount needed for redemption
     */
    fetchSwapAmount(payload, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.post(`${this.env.API_URL}reward/sdk/swap-amount`, payload, {
                    "x-access-token": token,
                    Authorization: `Bearer ${token}`,
                    "x-public-key": this.env.ME_API_KEY,
                });
                return result.data;
            }
            catch (error) {
                console.error("Error fetching swap amount:", error);
                throw error;
            }
        });
    }
}
